import React, { Component } from 'react';
import {Popover,PopoverBody,PopoverHeader} from 'reactstrap';
import Tooltip from '../TooltipIcon/TooptipIcon';
import './Popover.css';

class OoPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen : false
    }
  }

  render() {
    const {isOpen} = this.state;
    const {target,headerText,bodyText,placement, css_class} = this.props;
    return(
      <span>
        <span
          id={target}
          className={`mr10 info_icon_mk ${css_class?css_class:''}`}
          onClick={() => { this.setState((p) => ({isOpen:!p.isOpen })) }}>
          <Tooltip />
        </span>
        <Popover placement={placement ? placement : `right`}
        className={css_class?css_class:''}
          isOpen={isOpen}
          target={target}
          toggle={() => { this.setState((p) => ({isOpen:!p.isOpen })) }}>
          <PopoverHeader className="popover-header-tooltip">
            {headerText}
          </PopoverHeader>
          <PopoverBody className="popover-body-tooltip">
            {bodyText}
          </PopoverBody>
        </Popover>
      </span>
    )
  }
}

export default OoPopover;